var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb')], 1)]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-2 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v("簽到活動管理")]), _c('div', {
    staticClass: "\n          col-12 col-xl-8\n          d-flex\n          flex-column flex-xl-row\n          align-items-start align-items-xl-center\n        "
  }, [_vm.checkPermission([_vm.consts.CHECKIN_CAMPAIGN_CREATE]) && !!this.query.merchant_id ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'CheckinCampaignCreate'
      }
    },
    on: {
      "click": _vm.handleCreate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 新增簽到活動 ")]) : _vm._e(), _c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.merchants.length == 2
    },
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "merchant_id", $$v);
      },
      expression: "query.merchant_id"
    }
  }), _c('b-form-select', {
    staticClass: "ml-2",
    attrs: {
      "options": _vm.isProcessingOptions
    },
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.is_processing,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "is_processing", $$v);
      },
      expression: "query.is_processing"
    }
  }), _c('b-form-select', {
    staticClass: "ml-2",
    attrs: {
      "options": _vm.statusOptions
    },
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "status", $$v);
      },
      expression: "query.status"
    }
  }), _c('b-input-group', {
    staticClass: "ml-0 ml-xl-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageReset.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.checkinCampaigns,
      "fields": _vm.fields
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "cell(start_at)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(" " + _vm._s(_vm.dateFormatter(data.item.start_at)) + " ")])];
      }
    }, {
      key: "cell(end_at)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(" " + _vm._s(_vm.dateFormatter(data.item.end_at)) + " ")])];
      }
    }, {
      key: "cell(is_processing)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.item.is_processing ? 'success' : 'danger'
          }
        }, [_vm._v(" " + _vm._s(data.item.is_processing ? '生效中' : '已失效') + " ")])];
      }
    }, {
      key: "cell(status)",
      fn: function fn(data) {
        return [data.item.status == 'draft' ? _c('b-badge', {
          attrs: {
            "variant": "warning"
          }
        }, [_vm._v(" 草稿 ")]) : _vm._e(), data.item.status == 'published' ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(" 發布 ")]) : _vm._e(), data.item.status == 'closed' ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(" 關閉 ")]) : _vm._e()];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.CHECKIN_MISSION_LIST_VIEW]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-info",
            "to": {
              name: 'CheckinMissionListByCampaign',
              params: {
                campaign_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-paw"
        }), _vm._v(" 任務 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.CHECKIN_CAMPAIGN_LIST_VIEW]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'CheckinCampaignView',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v(" 查看 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.CHECKIN_CAMPAIGN_MODIFY]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'CheckinCampaignEdit',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.CHECKIN_CAMPAIGN_DELETE]) ? _c('span', {
          staticStyle: {
            "display": "inline-block"
          },
          attrs: {
            "id": "delete-btn-wrapper-".concat(data.item.id)
          }
        }, [_c('b-button', {
          staticClass: "icon-btn",
          attrs: {
            "variant": "inverse-danger",
            "disabled": data.item.status != 'closed'
          },
          on: {
            "click": function click($event) {
              return _vm.deleteForm(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")])], 1) : _vm._e(), data.item.status != 'closed' ? _c('b-tooltip', {
          attrs: {
            "target": "delete-btn-wrapper-".concat(data.item.id),
            "triggers": "hover"
          }
        }, [_vm._v(" 只能刪除已關閉的活動 ")]) : _vm._e()];
      }
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }